export default "__VITE_PUBLIC_ASSET__bbc9ea43__"